module.exports = __webpack_public_path__ + "img/ts15.f2cbac86.png";